export const blacklist = (state) => state.blacklist;
